import React, { ReactNode } from 'react';

import { Modal, Button } from 'react-bootstrap';

interface IProps {
    show: boolean;
    class: string;
    size?: 'lg' | 'xl' | 'sm';

    title: string;
    children: ReactNode;
    hideHeader?: boolean;

    showConfirm?: boolean;
    showCancel?: boolean;

    onCancelText: string;
    onConfirmText: string;

    onCancel?: () => void;
    onConfirm?: () => void;
    onHide?: () => void;
}

const BaseModal = (props: IProps) => {

    const hasFooter = props.onCancel || props.onConfirm;

    const classes = `${!hasFooter ? 'modal-without-footer' : ''} ${props.class ? props.class : ''}`;

    function handleClick(callback: any) {
        if (callback)
            callback();
    }
    
    return (
        <Modal show={props.show}
            size={props.size}
            className={classes}
            animation={false}
            backdrop="static"
            keyboard={false}
            style={{zIndex: (props.title?.toLowerCase().includes('erro'))? '9999999':'1040'}}
            onHide={props.onHide ? props.onHide : () => { }}
        >
            {
                !props.hideHeader &&
                <Modal.Header>
                    <Modal.Title>{props.title}</Modal.Title>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                        onClick={() => handleClick(props?.onHide)}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </Modal.Header>
            }
            <Modal.Body>
                {props.children}
            </Modal.Body>
            {
                hasFooter &&
                <Modal.Footer>
                    {
                        props.onCancel &&
                        (props.showCancel??true) &&
                        <Button className="btn btn-danger btnNO" onClick={() => handleClick(props?.onCancel)}>
                            {props.onCancelText}
                        </Button>
                    }
                    {
                        props.onConfirm &&
                        (props.showConfirm??true) &&
                        <Button className="btn btn-success btnOk" onClick={() => handleClick(props?.onConfirm)}>
                            {props.onConfirmText}
                        </Button>
                    }
                </Modal.Footer>
            }
        </Modal>
    );
};

export default BaseModal;